import React, { useEffect, useState } from 'react'
import profileBanner from '../../Assets/images/profile-bnr.webp'
import { useLocation, useParams } from 'react-router-dom'
import useMakeRequest from '../../utils/ApiHelper'
import { ApiConstants } from '../../constants/ApiConstants'
import Logo from '../../Assets/images/cms-logo.png'
import FrontLoader from '../layout/FrontLoader'

function AppCms() {
  const { id } = useParams()
  const path_name = useLocation()
  const CMS = useMakeRequest()
  const [data, setData] = useState<any>({})

  const path = path_name?.pathname.split('/')

  useEffect(() => {
    if(id){
      const payload = {
        "slug": path[2],
        "user_type": 2,
        lang_id:id
      }
      CMS.makeRequest({ payload, url: ApiConstants?.Cms, toastStatus: false })
    }
  }, [id])

  useEffect(() => {
    if (CMS?.status) {
      setData(CMS?.data?.data)
    }
  }, [CMS?.status])


  return (
    <>
      <main>
       
        <div className="container footer-space cms-content">
        <div className="pro-sugg-img" style={{textAlign:'center'}} >   
                   <img src={Logo} alt="product" />
             </div>
          <h2 className="title-1 mt-4 mb-2">{data?.cms_pages_details?.title}</h2>
          <p
            className="com-para"
            dangerouslySetInnerHTML={{ __html: data?.cms_pages_details?.content }}
          ></p>
        </div>

      </main>

    </>
  )
}


export default AppCms